import type { Template } from "@/types";

export const PO_06_H5_V1: Template[] = [
    {
        id: "po-06-h5v1-01",
        name: "PO 01 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 36, y: 157, width: 336, height: 537, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 379, y: 157, width: 184, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 379, y: 294, width: 184, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 379, y: 430, width: 184, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 379, y: 566, width: 184, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 637, y: 240, width: 510, height: 370, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-02",
        name: "PO 02 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 54, y: 253, width: 228, height: 344, rotation: 0, imageRotation: 0 },
            { id: "2", x: 648, y: 183, width: 478, height: 317, rotation: 0, imageRotation: 0 },
            { id: "3", x: 290, y: 253, width: 254, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 290, y: 429, width: 254, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 648, y: 508, width: 235, height: 158, rotation: 0, imageRotation: 0 },
            { id: "6", x: 891, y: 508, width: 235, height: 158, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-03",
        name: "PO 03 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 43, y: 240, width: 510, height: 370, rotation: 0, imageRotation: 0 },
            { id: "2", x: 627, y: 157, width: 336, height: 538, rotation: 0, imageRotation: 0 },
            { id: "3", x: 970, y: 157, width: 184, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 970, y: 294, width: 184, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 970, y: 431, width: 184, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 970, y: 567, width: 184, height: 128, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-04",
        name: "PO 04 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 83, y: 142, width: 422, height: 275, rotation: 0, imageRotation: 0 },
            { id: "2", x: 702, y: 142, width: 380, height: 566, rotation: 0, imageRotation: 0 },
            { id: "3", x: 83, y: 424, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 83, y: 570, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 298, y: 424, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 298, y: 570, width: 207, height: 138, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-05",
        name: "PO 05 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 56, y: 252, width: 483, height: 345, rotation: 0, imageRotation: 0 },
            { id: "2", x: 659, y: 559, width: 151, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 818, y: 559, width: 308, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 659, y: 66, width: 467, height: 312, rotation: 0, imageRotation: 0 },
            { id: "5", x: 659, y: 385, width: 230, height: 166, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 385, width: 229, height: 166, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-06",
        name: "PO 06 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 268, width: 232, height: 153, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 429, width: 232, height: 153, rotation: 0, imageRotation: 0 },
            { id: "3", x: 240, y: 268, width: 232, height: 153, rotation: 0, imageRotation: 0 },
            { id: "4", x: 240, y: 429, width: 232, height: 153, rotation: 0, imageRotation: 0 },
            { id: "5", x: 480, y: 268, width: 209, height: 314, rotation: 0, imageRotation: 0 },
            { id: "6", x: 697, y: 268, width: 493, height: 314, rotation: 0, imageRotation: 0 } 
        ],
    },

    {
        id: "po-06-h5v1-07",
        name: "PO 07 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 201, width: 297, height: 449, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 304, y: 201, width: 173, height: 107, rotation: 0, imageRotation: 0 },
            { id: "3", x: 304, y: 316, width: 173, height: 106, rotation: 0, imageRotation: 0 },
            { id: "4", x: 304, y: 430, width: 173, height: 106, rotation: 0, imageRotation: 0 },
            { id: "5", x: 304, y: 544, width: 173, height: 106, rotation: 0, imageRotation: 0 },
            { id: "6", x: 484, y: 201, width: 705, height: 449, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-08",
        name: "PO 08 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 61, y: 538, width: 249, height: 172, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 140, width: 249, height: 391, rotation: 0, imageRotation: 0 },
            { id: "3", x: 318, y: 140, width: 403, height: 282, rotation: 0, imageRotation: 0 },
            { id: "4", x: 318, y: 430, width: 403, height: 281, rotation: 0, imageRotation: 0 },
            { id: "5", x: 729, y: 140, width: 403, height: 282, rotation: 0, imageRotation: 0 },
            { id: "6", x: 729, y: 430, width: 403, height: 281, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-09",
        name: "PO 09 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 61, y: 143, width: 204, height: 306, rotation: 0, imageRotation: 0 },
            { id: "2", x: 273, y: 143, width: 425, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 706, y: 143, width: 424, height: 306, rotation: 0, imageRotation: 0 },
            { id: "4", x: 61, y: 456, width: 352, height: 251, rotation: 0, imageRotation: 0 },
            { id: "5", x: 421, y: 456, width: 351, height: 251, rotation: 0, imageRotation: 0 },
            { id: "6", x: 780, y: 456, width: 351, height: 251, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-10",
        name: "PO 10 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_10.png",
        size: [1190, 850],
        style: {},
        slots: [           
            { id: "1", x: 74, y: 146, width: 270, height: 181, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 335, width: 270, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 74, y: 524, width: 270, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 352, y: 146, width: 375, height: 558, rotation: 0, imageRotation: 0 },
            { id: "5", x: 735, y: 146, width: 375, height: 275, rotation: 0, imageRotation: 0 },
            { id: "6", x: 735, y: 429, width: 375, height: 275, rotation: 0, imageRotation: 0 }
        ],
    }
];